import { NgModule, ModuleWithProviders } from '@angular/core';
import { AnalyticsService } from './service/analytics.service';

@NgModule({})
export class GoogleAnalyticsModule {
  static forRoot(): ModuleWithProviders<GoogleAnalyticsModule> {
    return {
      ngModule: GoogleAnalyticsModule,
      providers: [
        AnalyticsService
      ]
    };
  }
}
